export const PHARMACIST_TAB_LABELS = {
  dashboard: 'Dashboard',
  createShift: 'Create Shift',
  manageShifts: 'Manage Shifts',
  bookingsApplicants: 'Bookings',
  profile: 'Profile'
} as const;

export const LOCUM_TAB_LABELS = {
  dashboard: 'Dashboard',
  findShifts: 'Find Shifts',
  myBookings: 'My Bookings',
  profile: 'Profile'
} as const;

export const ADMIN_TAB_LABELS = {
  dashboard: 'Dashboard',
  userManagement: 'User Management',
  manageLocum: 'Manage Locum',
  managePharmacy: 'Manage Pharmacy',
  reports: 'Reports',
  userReport: 'User Report',
  shiftReport: 'Shift Report',
  bookingReport: 'Booking Report'
} as const;
